import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_ITEMS_BY_PROFORMA_ID = '[PROFORMA ITEMS] GET ITEMS BY PROFORMA ID'
export const SAVE_PROFORMA_ITEM = '[PROFORMA ITEMS] SAVE PROFORMA ITEM'
export const ADD_QUANTITY_TO_PROFORMA_ITEM = '[PROFORMA ITEMS] ADD QUANTITY TO PROFORMA ITEM'
export const SUBTRACT_QUANTITY_TO_PROFORMA_ITEM = '[PROFORMA ITEMS] SUBTRACT QUANTITY TO PROFORMA ITEM'
export const SAVE_PROFORMA_ITEM_DESCRIPTION = '[PROFORMA ITEMS] SAVE PROFORMA ITEM DESCRIPTION'
export const UPDATE_PROFORMA_ITEM_PRICE = '[PROFORMA ITEMS] UPDATE PROFORMA ITEM PRICE'
export const REMOVE_PROFORMA_ITEM = '[PROFORMA ITEMS] REMOVE PROFORMA ITEM'

export function getItemsByProformaIdAction(proformaId) {
  const request = api.get(`/proforma-items/by-proforma/${proformaId}`)
  return (dispatch) => {
    dispatch({ type: GET_ITEMS_BY_PROFORMA_ID, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_ITEMS_BY_PROFORMA_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_ITEMS_BY_PROFORMA_ID, error)
    }).finally(() => {
      dispatch({ type: GET_ITEMS_BY_PROFORMA_ID, payload: { loading: false } })
    })
  }
}

export function saveProformaItemAction(data) {
  const request = api.post(`/proforma-item/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_PROFORMA_ITEM, payload: { saving: true } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_PROFORMA_ITEM, payload: { saved: true, data: response.data.data } })
      toast.success(response.data.message)
    }).catch((error) => {
      console.log(SAVE_PROFORMA_ITEM, error)
    }).finally(() => {
      dispatch({ type: SAVE_PROFORMA_ITEM, payload: { saving: false } })
    })
  }
}

export function addQuantityToProformaItemAction(proformaItemId, quantity) {
  const request = api.put(`/proforma-item/${proformaItemId}/add-quantity/${quantity}`)
  return (dispatch) => {
    dispatch({ type: ADD_QUANTITY_TO_PROFORMA_ITEM, payload: { adding_id: proformaItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: ADD_QUANTITY_TO_PROFORMA_ITEM, payload: { added_id: proformaItemId, data: response.data.data } })
    }).catch((error) => {
      console.log(ADD_QUANTITY_TO_PROFORMA_ITEM, error)
    }).finally(() => {
      dispatch({ type: ADD_QUANTITY_TO_PROFORMA_ITEM, payload: { adding_id: proformaItemId } })
    })
  }
}

export function subtractQuantityToProformaItemAction(proformaItemId, quantity) {
  const request = api.put(`/proforma-item/${proformaItemId}/subtract-quantity/${quantity}`)
  return (dispatch) => {
    dispatch({ type: SUBTRACT_QUANTITY_TO_PROFORMA_ITEM, payload: { subtracting_id: proformaItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SUBTRACT_QUANTITY_TO_PROFORMA_ITEM, payload: { subtracted_id: proformaItemId, data: response.data.data } })
    }).catch((error) => {
      console.log(SUBTRACT_QUANTITY_TO_PROFORMA_ITEM, error)
    }).finally(() => {
      dispatch({ type: SUBTRACT_QUANTITY_TO_PROFORMA_ITEM, payload: { subtracting_id: proformaItemId } })
    })
  }
}

export function saveProformaItemDescriptionAction(proformaItemId, description) {
  const request = api.put(`/proforma-item/${proformaItemId}/description/${description}`)
  return (dispatch) => {
    dispatch({ type: SAVE_PROFORMA_ITEM_DESCRIPTION, payload: { saving_id: proformaItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_PROFORMA_ITEM_DESCRIPTION, payload: { saved_id: proformaItemId, data: response.data.data } })
    }).catch((error) => {
      console.log(SAVE_PROFORMA_ITEM_DESCRIPTION, error)
    }).finally(() => {
      dispatch({ type: SAVE_PROFORMA_ITEM_DESCRIPTION, payload: { saving_id: proformaItemId } })
    })
  }
}

export function updateProformaItemPriceAction(proformaItemId, price, password = null) {
  const request = api.put(`/proforma-item/${proformaItemId}/price/${price}/${password}`)
  return (dispatch) => {
    dispatch({ type: UPDATE_PROFORMA_ITEM_PRICE, payload: { updating_id: proformaItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: UPDATE_PROFORMA_ITEM_PRICE, payload: { updated_id: proformaItemId, data: response.data.data } })
    }).catch((error) => {
      console.log(UPDATE_PROFORMA_ITEM_PRICE, error)
    }).finally(() => {
      dispatch({ type: UPDATE_PROFORMA_ITEM_PRICE, payload: { updating_id: proformaItemId } })
    })
  }
}

export function removeProformaItemAction(proformaItemId) {
  const request = api.delete(`/proforma-item/remove/${proformaItemId}`)
  return (dispatch) => {
    dispatch({ type: REMOVE_PROFORMA_ITEM, payload: { removing_id: proformaItemId } })
    request.then((response) => {
      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: REMOVE_PROFORMA_ITEM, payload: { removed_id: proformaItemId } })
    }).catch((error) => {
      console.log(REMOVE_PROFORMA_ITEM, error)
    }).finally(() => {
      dispatch({ type: REMOVE_PROFORMA_ITEM, payload: { removing_id: proformaItemId } })
    })
  }
}
